module.exports = __webpack_public_path__ + "static/media/logo-v.6c003338.svg";